import { IPackingAlgorithm } from "./common";
import { GridState, GridItem } from "../gridState";
import { GridSpaceTracker } from "./gridSpaceTracker";
import { GridPosition } from "client/Api/Workspace/common";
import { sortBy } from "client_legacy/ndaw/arrayHelpers";


class TopLeftPackingAlgorithm implements IPackingAlgorithm {
	private readonly _desiredColumnSpan: number;

	constructor(desiredColumnSpan: number) {
		this._desiredColumnSpan = desiredColumnSpan;
	}

	public applyTo<TItem>(state: GridState<TItem>) {
		const desiredColumnSpan: number = this._desiredColumnSpan;

		const containsItemsWiderThanDesiredColumnSpan: boolean = state.gridItems.some(
			(item) => item.dimension.columnSpan > desiredColumnSpan
		);

		if (containsItemsWiderThanDesiredColumnSpan) {
			throw new Error("Not all items fit within the given desired column span");
		}

		const orderedGridItems: GridItem<TItem>[] = sortBy(
			state.gridItems,
			// Sort they items based on column as if they were all on the same row
			(item: GridItem<TItem>) => (item.position.row * state.dimension.columnSpan) + item.position.column
		);

		const tracker = new GridSpaceTracker(desiredColumnSpan);

		for (const gridItem of orderedGridItems) {
			const position: GridPosition = tracker.commitFirstAvailablePosition(gridItem.dimension);
			gridItem.position = position;
		}
	}
}

export {
	TopLeftPackingAlgorithm,
};
